import { Relation } from '@/layout/fields/relation'

export class MultiselectField extends Relation {
}
